import { useState, useCallback } from 'react'
import axios from 'axios'

interface UseReviewsProps {
  initialReviews: any[]
  totalReviews: number
  productId: string
}

function advanceRange(range: string, increment: number, maxLimit: number) {
  const [lowerLimit, upperLimit] = range.split('-').map(Number)

  const newLowerLimit = lowerLimit + increment
  const newUpperLimit = upperLimit + increment

  const adjustedUpperLimit = Math.min(newUpperLimit, maxLimit)

  const adjustedLowerLimit =
    newUpperLimit === maxLimit
      ? Math.max(newLowerLimit, maxLimit - (upperLimit - lowerLimit))
      : newLowerLimit

  return `${adjustedLowerLimit}-${adjustedUpperLimit}`
}

export function useReviews({
  initialReviews,
  totalReviews,
  productId,
}: UseReviewsProps) {
  const [reviews, setReviews] = useState(initialReviews)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState('0-2')

  const handleGetMoreReviews = useCallback(async () => {
    try {
      setLoading(true)
      const nextRange = advanceRange(currentPage, 3, totalReviews)

      const { data } = await axios.post('/api/pdp/review', {
        productId,
        range: nextRange,
      })

      const reviewsResponse = data?.data?.DktPdp_GetProductReview?.reviews

      setReviews((current) => [
        ...current,
        ...(Array.isArray(reviewsResponse) ? reviewsResponse : []),
      ])

      setCurrentPage(nextRange)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }, [currentPage, totalReviews, productId])

  return { reviews, loading, handleGetMoreReviews, currentPage }
}
